<section
  class="facet-list"
  *ngIf="(facetList$ | async)?.facets as facets"
  [class.active]="isActive"
  [class.dialog]="isInDialog"
  [attr.aria-label]="'rrs.productFacetNavigation.filterBy.facet' | cxTranslate"
  [tabindex]="-1"
  (keydown.enter)="stopPropagation($event)"
  (click)="stopPropagation($event)"
  (esc)="apply()">
  <div
    class="facet-list__header d-flex d-lg-none justify-content-between align-items-center py-2 px-3">
    <span>{{ 'rrs.productFacetNavigation.filterBy.label' | cxTranslate }}</span>
    <button
      type="button"
      class="close"
      [attr.aria-label]="'rrs.common.close' | cxTranslate"
      (click)="apply()">
      <rrs-icon
        aria-hidden="true"
        [icon]="iconTypeList.CLOSE"
        [size]="16"></rrs-icon>
    </button>
  </div>
  <div
    *ngIf="pagination$ | async as pagination"
    class="facet-list__info d-flex d-lg-none justify-content-between align-items-center p-3">
    <span
      >{{ pagination?.totalResults }}&nbsp;{{
        'rrs.productListing.itemsFound' | cxTranslate
      }}</span
    >
    <div class="d-flex align-items-center">
      <span>
        {{ 'rrs.productListing.view' | cxTranslate }}
        <a
          [routerLink]="[]"
          [queryParams]="{
            pageSize: null,
            currentPage:
              pagination.pageSize === pageSizeOptions.default
                ? pagination.currentPage
                : 0
          }"
          queryParamsHandling="merge"
          class="text-decoration-underline"
          [class.fw-bold]="pagination.pageSize === pageSizeOptions.default"
          >{{ pageSizeOptions.default }}</a
        >
        {{ 'rrs.productListing.or' | cxTranslate }}
        <a
          [routerLink]="[]"
          [queryParams]="{
            pageSize: pageSizeOptions.increased,
            currentPage:
              pagination.pageSize === pageSizeOptions.increased
                ? pagination.currentPage
                : 0
          }"
          queryParamsHandling="merge"
          class="text-decoration-underline"
          [class.fw-bold]="pagination.pageSize === pageSizeOptions.increased"
          >{{ pageSizeOptions.increased }}</a
        >
        {{ 'rrs.productListing.items' | cxTranslate }}
      </span>
      <rrs-icon
        *ngIf="viewMode$ | async as viewMode"
        class="ms-2 cursor-pointer"
        [icon]="
          viewMode === viewModes.Grid
            ? iconTypeList.LIST_UNCHECKED
            : iconTypeList.GRID_UNCHECKED
        "
        role="button"
        (click)="setViewMode(viewMode)"
        (keydown.enter)="setViewMode(viewMode)"
        [size]="35"></rrs-icon>
    </div>
  </div>

  <ng-container
    *ngIf="{ currentSearchQuery: currentSearchQuery$ | async } as data">
    <rrs-facet
      *ngFor="let facet of facets; trackBy: getFacetName"
      #facetRef
      [facet]="facet"
      [currentSearchQuery]="data.currentSearchQuery"
      [class.expanded]="isExpanded(facet) | async"
      [class.collapsed]="isCollapsed(facet) | async"
      role="group"
      attr.aria-label="{{
        'rrs.productFacetNavigation.ariaLabelItemsAvailable'
          | cxTranslate
            : {
                name: facet.name,
                count: facet?.values?.length
              }
      }}">
    </rrs-facet>
  </ng-container>
</section>
<div
  *ngIf="isInDialog"
  class="d-flex justify-content-center fixed-bottom z-2000 bg-secondary row d-lg-none">
  <div class="row pt-3">
    <rrs-dialog-active-facets
      class="mobile-active-facets"></rrs-dialog-active-facets>
  </div>
  <div class="row py-3">
    <button
      type="button"
      class="btn btn-md btn-secondary mx-3 col"
      (click)="cancel()">
      Cancel
    </button>
    <button
      type="button "
      class="btn btn-md btn-primary mx-3 col"
      (click)="apply()">
      Apply
    </button>
  </div>
  <div class="row pb-4">
    <a
      (click)="closeDialog()"
      [routerLink]="{ cxRoute: 'search' } | cxUrl"
      [queryParams]="{ facetFilters: null, currentPage: null }"
      queryParamsHandling="merge"
      class="clear d-lg-none text-center text-decoration-underline"
      data-cy="clearFacets">
      {{ 'rrs.productListing.clearAllFilters' | cxTranslate }}
    </a>
  </div>
</div>
